/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import TipoMonedaForm from './TipoMonedaForm';
import * as validations from '../../validations/validations';
import * as tipomonedaActions from '../../actions/tipomonedaActions';
import * as userActions from '../../actions/userActions';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
 import $ from 'jquery';


class ManageTipoMonedaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			tipomoneda:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        /*
        let id=this.props.id;
        let pageInfo={ 
            page:'tipomoneda', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        */
        let id=this.props.id;
        usuarioActual(this, "tipomoneda",true).then( (usuario)=>{
            if(id && id>0 ){

               this.props.tipomonedaActions.getTipoMoneda(id, usuario).then( tipomoneda=>{
                   this.setState({"tipomoneda":tipomoneda});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
         })
        .catch(error=>{
          toastr.error(error);
        }); 
		
    }
    

    handleChange=(event, data)=> {

        let tipomoneda = this.state.tipomoneda;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		tipomoneda[field[0]]= value;
		else{
             if(!tipomoneda[field[0]]){
                    tipomoneda[field[0]]={}
                }
			tipomoneda[field[0]][field[1]]= value;
		}
        
		
        this.setState({"tipomoneda": tipomoneda});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let tipomoneda=this.state.tipomoneda;
              
        if(!validations.requerido(tipomoneda.moneda)){
            errors.moneda=true;
            formIsValid=false;
        }
       
      
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.tipomonedaActions.save(this.state.tipomoneda, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <TipoMonedaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.tipomoneda}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings, 
        form:state.form
    }

}

function mapDispatchToProps(dispatch){

    return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        tipomonedaActions: bindActionCreators(tipomonedaActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageTipoMonedaForm));